import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var RotateRightSvg = function RotateRightSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.41 2.5a9.33 9.33 0 0 0-6.186 2.337 9.53 9.53 0 0 0-3.138 5.877 9.6 9.6 0 0 0 1.464 6.513 9.4 9.4 0 0 0 5.34 3.93 9.3 9.3 0 0 0 6.579-.597 9.46 9.46 0 0 0 4.565-4.827l-1.363-.589a7.96 7.96 0 0 1-3.845 4.066 7.83 7.83 0 0 1-5.54.502 7.92 7.92 0 0 1-4.499-3.31 8.07 8.07 0 0 1-1.232-5.485 8.03 8.03 0 0 1 2.642-4.95 7.86 7.86 0 0 1 5.211-1.969 7.86 7.86 0 0 1 5.205 1.987A8 8 0 0 1 18.99 9.76l-2.911-.944-.453 1.427 4.826 1.564L22 6.927l-1.411-.457-.564 1.777a9.5 9.5 0 0 0-2.435-3.389A9.34 9.34 0 0 0 11.41 2.5",
    clipRule: "evenodd"
  }));
};
export var RotateRight = function RotateRight(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: RotateRightSvg
  }));
};